import { User } from "../model/User";
import { IUserState } from "./state/IUserState";

export interface IUserService extends IUserState {
  current(): User | undefined;
  save(user: User): void;
  clear(): void
}
export const UserService = Symbol.for("UserService");